// extracted by mini-css-extract-plugin
export default {"company":"add-organization_company__rJtqM","nameHelper":"add-organization_nameHelper__bAPeg","afterError":"add-organization_afterError__3FWBd"};